import Cookies from 'js-cookie';

export const getTokens = () => ({
  userToken: Cookies.get('token'),
  adminToken: Cookies.get('admin_token'),
  superAdminToken: Cookies.get('superadmin_token'),
  branchCode: Cookies.get('branchCode'),
  companyCode: Cookies.get('companyCode'),
});

export const getUserRedirect = ({ userToken, branchCode, companyCode }) => {
  if (userToken && branchCode && companyCode) return '/dashboard';
  if (userToken && companyCode) return '/userwise/branch/list/';
  if (userToken) return '/userwise/company/list/';
  return null;
};
